<template>
  <div class="grid-container fluid city-council">
    <div class="grid-container first-member">
      <h2 class="header">
        {{ $t("city-council.city-council") }}
      </h2>
      <hr>
      <a
        class="grid-x member-container"
        href="https://phlcouncil.com/KenyattaJohnson/"
      >
        <div class="cell medium-10 headshot">
          <img
            src="https://www.phila.gov/assets/images/website/city_council/Kenyatta_Johnson.png"
            alt="Kenyatta Johnson headshot"
          >
        </div>
        <span class="cell medium-14 content">
          <div class="name">Kenyatta Johnson</div>
          <div class="district">District 2</div>
          <div class="designation">{{ $t("city-council.council-president") }}</div>
          <div class="ptl">
            <div class="button">{{ $t("mayor.learn-more") }} <i class="fa-solid fa-arrow-up-right-from-square" /></div>
          </div>
        </span>
      </a>
    </div>
    <div class="grid-container members-grid pbxl">
      <div class="grid-x grid-margin-x">
        <div
          v-for="(user, index) in users"
          :key="index"
          class="cell medium-6 mvl member-wrap"
        >
          <a
            class="content-card grid-x"
            :href="user.url"
          >
            <img
              :src="getImagePath(user.image)"
              class="cell small-12 medium-24"
              alt="Council person headshot"
            >
            <div class="ptl pbxl cell auto info">
              <div class="name">{{ user.name }}</div>
              <div class="designation">{{ $t(user.unique_title_key) }}</div>
              <div class="type">{{ $t(user.type_key ) }}</div>
              <div class="district">{{ user.district }}</div>
            </div>
            <a class="button">{{ $t("mayor.learn-more") }} <i class="fa-solid fa-arrow-up-right-from-square" /></a>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userData from '@/assets/city-council-members.json';

export default {
  data() {
    return {
      users: userData,
    };
  },
  methods: {
    getImagePath(image) {
      try {
        return `https://www.phila.gov/assets/images/website/city_council/${image}`;
      } catch (error) {
        return ;
      }
    },
  },
};
</script>
